import {
  Accessibility,
  Activity,
  Airplay,
  AirVent,
  AlarmClock,
  AlarmSmoke,
  Ambulance,
  Anchor,
  Antenna,
  Anvil,
  Aperture,
  Apple,
  AppWindow,
  AppWindowMac,
  Archive,
  ArchiveRestore,
  Armchair,
  Astroid,
  Atom,
  AtSign,
  AudioLines,
  AudioWaveform,
  Award,
  Axe,
  Baby,
  Backpack,
  Badge,
  BadgeCheck,
  BaggageClaim,
  Balloon,
  Banana,
  Bandage,
  Banknote,
  Barcode,
  Barrel,
  Bath,
  Battery,
  BatteryCharging,
  BatteryFull,
  Beaker,
  Bean,
  Bed,
  BedDouble,
  BedSingle,
  Beef,
  Beer,
  Bell,
  BellElectric,
  BellOff,
  BellRing,
  BicepsFlexed,
  Bike,
  Binary,
  Binoculars,
  Biohazard,
  Bird,
  Birdhouse,
  Bitcoin,
  Blender,
  Blinds,
  Blocks,
  Bluetooth,
  BluetoothConnected,
  BluetoothSearching,
  Bolt,
  Bomb,
  Bone,
  BoneFracture,
  Book,
  BookA,
  BookAudio,
  BookCopy,
  BookHeadphones,
  BookHeart,
  BookImage,
  BookKey,
  BookLock,
  BookMarked,
  Bookmark,
  BookOpen,
  BookOpenText,
  BookText,
  BookType,
  BookUser,
  BoomBox,
  Bot,
  BotMessageSquare,
  BottleWine,
  BowArrow,
  Box,
  Boxes,
  Braces,
  Brackets,
  Brain,
  BrainCircuit,
  BrickWall,
  BrickWallFire,
  BrickWallShield,
  Bridge,
  Briefcase,
  BriefcaseBusiness,
  BriefcaseConveyorBelt,
  BriefcaseMedical,
  Broccoli,
  Broom,
  BroomSparkles,
  Brush,
  BrushCleaning,
  Bubbles,
  Bug,
  BugPlay,
  Building,
  Building2,
  Bus,
  BusFront,
  Cable,
  CableCar,
  Cake,
  CakeSlice,
  Calculator,
  Calendar,
  CalendarCheck,
  CalendarClock,
  CalendarDays,
  CalendarFold,
  CalendarHeart,
  CalendarRange,
  Calendars,
  Camera,
  Can,
  Candy,
  CandyCane,
  Cannabis,
  CanSoda,
  Captions,
  Car,
  Caravan,
  CarBattery,
  CardSim,
  CarFront,
  Carrot,
  CarTaxiFront,
  CassetteTape,
  Cast,
  Castle,
  Cat,
  Cctv,
  ChartArea,
  ChartBar,
  ChartCandlestick,
  ChartColumn,
  ChartGantt,
  ChartLine,
  ChartNetwork,
  ChartPie,
  ChartScatter,
  ChartSpline,
  Check,
  ChefHat,
  Cherry,
  ChessBishop,
  ChessKing,
  ChessKnight,
  ChessPawn,
  ChessQueen,
  ChessRook,
  Church,
  Cigarette,
  Circle,
  CircleAlert,
  CircleCheck,
  CircleUser,
  CircuitBoard,
  Citrus,
  Clapperboard,
  Clipboard,
  ClipboardCheck,
  ClipboardClock,
  ClipboardCopy,
  ClipboardList,
  ClipboardPaste,
  ClipboardPen,
  ClipboardType,
  Clock,
  ClosedCaption,
  Cloud,
  CloudDownload,
  CloudDrizzle,
  CloudFog,
  CloudHail,
  CloudLightning,
  CloudMoon,
  CloudMoonRain,
  CloudOff,
  CloudRain,
  CloudRainWind,
  CloudSnow,
  CloudSun,
  CloudSunRain,
  CloudUpload,
  Cloudy,
  Clover,
  Club,
  Code,
  CodeXml,
  Coffee,
  Cog,
  Coins,
  Command,
  Compass,
  Component,
  Computer,
  ConciergeBell,
  Cone,
  Construction,
  Contact,
  Container,
  Cookie,
  CookingPot,
  Copyleft,
  Copyright,
  Cpu,
  CreativeCommons,
  CreditCard,
  CreditCardReader,
  Croissant,
  Cross,
  Crosshair,
  Crown,
  Cuboid,
  CupSoda,
  Currency,
  Cylinder,
  Dam,
  Database,
  DatabaseZap,
  Dessert,
  Diamond,
  DiamondPercent,
  Dices,
  Disc,
  DiscAlbum,
  Dna,
  Dog,
  DollarSign,
  Donut,
  DoorClosedLocked,
  DoorOpen,
  DoorStairwell,
  Download,
  DraftingCompass,
  Drama,
  Drill,
  Drone,
  Droplet,
  Droplets,
  Drum,
  Drumstick,
  Dumbbell,
  Ear,
  Earth,
  EarthLock,
  Eclipse,
  Egg,
  EggFried,
  Engine,
  Eraser,
  EthernetPort,
  Euro,
  EvCharger,
  ExternalLink,
  Eye,
  EyeOff,
  FaceAngry,
  FaceExpressionless,
  FaceGrinning,
  FaceNeutral,
  FaceSlightlyFrowning,
  FaceSlightlySmiling,
  Factory,
  Fan,
  Feather,
  Fence,
  FerrisWheel,
  FileArchive,
  FileBox,
  FileBraces,
  FileChartColumn,
  FileChartColumnIncreasing,
  FileChartLine,
  FileChartPie,
  FileCheck,
  FileClock,
  FileCode,
  FileDigit,
  FileHeadphone,
  FileHeart,
  FileIcon,
  FileImage,
  FileKey,
  FileLock,
  FileMusic,
  FilePen,
  FilePlay,
  FileSignal,
  FileSliders,
  FileSpreadsheet,
  FileStack,
  Files,
  FileTerminal,
  FileText,
  FileType,
  FileUser,
  FileVideoCamera,
  FileVolume,
  Film,
  FingerprintPattern,
  FireExtinguisher,
  Fish,
  FishingHook,
  FishingRod,
  FishSymbol,
  Flag,
  FlagTriangleLeft,
  FlagTriangleRight,
  Flame,
  FlameKindling,
  Flashlight,
  FlaskConical,
  Flower,
  Flower2,
  Folder,
  FolderArchive,
  FolderBookmark,
  FolderClock,
  FolderCode,
  FolderGit,
  FolderHeart,
  FolderKanban,
  FolderKey,
  FolderLock,
  FolderOpen,
  Folders,
  FolderTree,
  Footprints,
  Forklift,
  Fuel,
  Funnel,
  Galaxy,
  Gamepad,
  Gamepad2,
  GamepadDirectional,
  Gauge,
  Gavel,
  Gem,
  GeorgianLari,
  Germ,
  Ghost,
  Gift,
  GitBranch,
  GitCommitHorizontal,
  GitCommitVertical,
  GitCompare,
  GitFork,
  GitGraph,
  GitMerge,
  GitPullRequest,
  Glasses,
  GlassWater,
  Globe,
  GlobeLock,
  Goal,
  Gpu,
  GraduationCap,
  Grape,
  Guitar,
  Ham,
  Hamburger,
  Hammer,
  Hand,
  Handbag,
  HandCoins,
  HandFist,
  HandGrab,
  HandHeart,
  HandPlatter,
  Handshake,
  HardDrive,
  HardHat,
  Hash,
  HatGlasses,
  Haze,
  HdmiPort,
  Headphones,
  Headset,
  Heart,
  HeartCrack,
  HeartHandshake,
  HeartPulse,
  Heater,
  Helicopter,
  HelpCircle,
  Hexagon,
  Highlighter,
  History,
  Hop,
  Hospital,
  Hotel,
  Hourglass,
  House,
  HouseHeart,
  HousePlug,
  HouseWifi,
  IceCreamBowl,
  IceCreamCone,
  IdCard,
  IdCardLanyard,
  Image,
  ImagePlay,
  Images,
  ImageUpscale,
  Inbox,
  IndianRupee,
  InfinityIcon,
  Info,
  InspectionPanel,
  JapaneseYen,
  Joystick,
  Kanban,
  Kayak,
  Key,
  Keyboard,
  KeyboardMusic,
  KeyRound,
  KeySquare,
  Lamp,
  LampCeiling,
  LampDesk,
  LampFloor,
  Landmark,
  LandPlot,
  Languages,
  Laptop,
  LaptopMinimal,
  Layers,
  Leaf,
  LeafyGreen,
  Lectern,
  LensConcave,
  LensConvex,
  Library,
  LifeBuoy,
  Ligature,
  Lightbulb,
  LightbulbOff,
  Lighthouse,
  Link,
  Link2,
  List,
  ListCheck,
  ListChecks,
  ListClock,
  ListMusic,
  ListTodo,
  Lock,
  LockKeyhole,
  LockKeyholeOpen,
  LockOpen,
  Lollipop,
  Luggage,
  Magnet,
  Mail,
  Mailbox,
  MailCheck,
  MailClock,
  MailOpen,
  Mails,
  MapIcon,
  MapPin,
  MapPinHouse,
  MapPinned,
  Mars,
  MarsStroke,
  Martini,
  Medal,
  Megaphone,
  MemoryStick,
  MessageCircle,
  MessageCircleCode,
  MessageCircleHeart,
  MessageSquare,
  MessageSquareCode,
  MessageSquareHeart,
  MessageSquareLock,
  MessageSquareQuote,
  MessageSquareShare,
  MessageSquareText,
  MessagesSquare,
  Metronome,
  Mic,
  MicOff,
  Microchip,
  Microscope,
  Microwave,
  MicVocal,
  MidiPort,
  Milestone,
  Milk,
  MirrorRectangular,
  Monitor,
  MonitorCloud,
  MonitorOff,
  MonitorPause,
  MonitorPlay,
  MonitorSmartphone,
  MonitorSpeaker,
  MonitorStop,
  Moon,
  MoonStar,
  Mop,
  MopSparkles,
  Mosque,
  Motorbike,
  Mountain,
  MountainSnow,
  Mouse,
  MouseLeft,
  MouseRight,
  Music,
  Navigation,
  Network,
  Newspaper,
  Nfc,
  Notebook,
  NotebookPen,
  NotebookTabs,
  NotebookText,
  NotepadText,
  Nut,
  Omega,
  Orbit,
  Origami,
  Package,
  Package2,
  PackageCheck,
  PackageOpen,
  PaintBucket,
  Paintbrush,
  PaintbrushVertical,
  PaintRoller,
  Palette,
  Panda,
  PaperBag,
  Paperclip,
  Parasol,
  Parentheses,
  ParkingMeter,
  PartyPopper,
  PawPrint,
  PcCase,
  Pen,
  Pencil,
  PencilLine,
  PencilRuler,
  PencilSparkles,
  PenLine,
  PenTool,
  Pentagon,
  Percent,
  PersonStanding,
  Phi,
  PhilippinePeso,
  Phone,
  PhoneCall,
  Pi,
  Piano,
  Pickaxe,
  PiggyBank,
  Pill,
  PillBottle,
  Pin,
  Pipette,
  Pizza,
  Plane,
  PlaneLanding,
  PlaneTakeoff,
  PlayingCard,
  PlayingCards,
  PlayingCardsFan,
  Plug,
  PlugZap,
  PocketKnife,
  Podium,
  Popcorn,
  Popsicle,
  PoundSterling,
  Power,
  Presentation,
  Printer,
  Projector,
  Puzzle,
  Pyramid,
  QrCode,
  Quote,
  Rabbit,
  Radar,
  Radiation,
  Radical,
  Radio,
  RadioReceiver,
  RadioTower,
  Rainbow,
  Rat,
  Receipt,
  ReceiptText,
  Recycle,
  RefreshCcw,
  RefreshCw,
  Refrigerator,
  Regex,
  Repeat,
  Reply,
  Ribbon,
  Road,
  RobotArm,
  RobotVacuum,
  Rocket,
  RockingChair,
  RollerCoaster,
  Rose,
  RotateCw,
  Route,
  Router,
  Rss,
  Ruler,
  RulerDimensionLine,
  RussianRuble,
  Sailboat,
  Salad,
  Sandwich,
  Satellite,
  SatelliteDish,
  SaudiRiyal,
  Save,
  Scale,
  Scan,
  School,
  Scissors,
  Scooter,
  ScreenShare,
  Scroll,
  ScrollText,
  Search,
  SearchCheck,
  SearchCode,
  Send,
  SendHorizontal,
  Server,
  ServerCrash,
  Settings,
  Shapes,
  Share,
  Share2,
  Shell,
  ShelvingUnit,
  Shield,
  ShieldCheck,
  ShieldKeyhole,
  ShieldLock,
  ShieldUser,
  Ship,
  ShipCargo,
  ShipWheel,
  Shirt,
  ShoppingBag,
  ShoppingBasket,
  ShoppingCart,
  Shovel,
  ShowerHead,
  Shredder,
  Shrimp,
  Shrub,
  Sigma,
  Signal,
  Signpost,
  Siren,
  Skull,
  SlidersHorizontal,
  SlidersVertical,
  Smartphone,
  SmartphoneCharging,
  SmartphoneNfc,
  Smile,
  Snail,
  Snowflake,
  SoapDispenserDroplet,
  Sofa,
  SolarPanel,
  Soup,
  Spade,
  Sparkle,
  Sparkles,
  Speaker,
  Speech,
  Spline,
  SportShoe,
  Spotlight,
  SprayCan,
  Sprout,
  Square,
  SquareCheck,
  SquareKanban,
  SquareLibrary,
  SquarePen,
  SquareTerminal,
  Squirrel,
  Stamp,
  Star,
  Stethoscope,
  Sticker,
  StickyNote,
  StickyNotes,
  Store,
  Sun,
  SunMoon,
  Sunrise,
  SunSnow,
  Sunset,
  SwatchBook,
  SwissFranc,
  Sword,
  Swords,
  Syringe,
  Table,
  Table2,
  TableOfContents,
  TableProperties,
  Tablet,
  TabletSmartphone,
  Tablets,
  Tag,
  Tags,
  Target,
  Telescope,
  Tent,
  TentTree,
  Terminal,
  TestTube,
  TestTubeDiagonal,
  TestTubes,
  Theater,
  Thermometer,
  ThermometerSnowflake,
  ThermometerSun,
  Ticket,
  TicketPercent,
  Tickets,
  TicketsPlane,
  Timeline,
  Timer,
  TimerReset,
  Toilet,
  Toolbox,
  ToolCase,
  Tornado,
  Torus,
  Touchpad,
  TowelRack,
  TowerControl,
  ToyBrick,
  Tractor,
  TrafficCone,
  Trailer,
  TrainFront,
  TrainFrontTunnel,
  TrainTrack,
  TramFront,
  Transgender,
  Trash,
  TreeDeciduous,
  TreePalm,
  TreePine,
  Trees,
  TrendingDown,
  TrendingUp,
  Triangle,
  TriangleRight,
  Trophy,
  Truck,
  TruckElectric,
  TurkishLira,
  Turntable,
  Turtle,
  Tv,
  TvMinimal,
  TvMinimalPlay,
  Umbrella,
  University,
  Unlock,
  Unplug,
  Upload,
  Usb,
  UsbCPort,
  User,
  UserCheck,
  UserKey,
  UserLock,
  UserPlus,
  UserRound,
  UserShield,
  UserStar,
  Users,
  Utensils,
  UtensilsCrossed,
  UtilityPole,
  Van,
  Variable,
  Vault,
  Vegan,
  VenetianMask,
  Venus,
  VenusAndMars,
  Vibrate,
  Video,
  VideoOff,
  Videotape,
  Virus,
  Voicemail,
  Volleyball,
  Volume,
  VolumeOff,
  Vote,
  Wallet,
  WalletCards,
  WalletMinimal,
  Wallpaper,
  Wand,
  WandSparkles,
  Warehouse,
  WashingMachine,
  Watch,
  WavesHorizontal,
  WavesLadder,
  WavesVertical,
  Waypoints,
  Webcam,
  Webhook,
  Weight,
  Wheat,
  Whistle,
  Wifi,
  WifiOff,
  Wind,
  Wine,
  Workflow,
  Worm,
  Wrench,
  Zap,
  ZodiacAquarius,
  ZodiacAries,
  ZodiacCancer,
  ZodiacCapricorn,
  ZodiacGemini,
  ZodiacLeo,
  ZodiacLibra,
  ZodiacOphiuchus,
  ZodiacPisces,
  ZodiacSagittarius,
  ZodiacScorpio,
  ZodiacTaurus,
  ZodiacVirgo,
} from 'lucide-react';
import type { ComponentType, SVGProps } from 'react';

import { isNoteIconName, type NoteIconName } from '../../../shared/note-icon';

/**
 * The drawn set is bundled rather than loaded as a webfont: pages must not make
 * external requests, and the icons are tree-shaken alongside the rest of the app.
 * Every name in `noteIconGroups` appears here; the record's type fails the build
 * when a catalogue entry has no glyph.
 */
const drawn: Record<NoteIconName, ComponentType<SVGProps<SVGSVGElement>>> = {
  accessibility: Accessibility,
  activity: Activity,
  'air-vent': AirVent,
  airplay: Airplay,
  'alarm-clock': AlarmClock,
  'alarm-smoke': AlarmSmoke,
  ambulance: Ambulance,
  anchor: Anchor,
  antenna: Antenna,
  anvil: Anvil,
  aperture: Aperture,
  'app-window': AppWindow,
  'app-window-mac': AppWindowMac,
  apple: Apple,
  archive: Archive,
  'archive-restore': ArchiveRestore,
  armchair: Armchair,
  astroid: Astroid,
  'at-sign': AtSign,
  atom: Atom,
  'audio-lines': AudioLines,
  'audio-waveform': AudioWaveform,
  award: Award,
  axe: Axe,
  baby: Baby,
  backpack: Backpack,
  badge: Badge,
  'badge-check': BadgeCheck,
  'baggage-claim': BaggageClaim,
  balloon: Balloon,
  banana: Banana,
  bandage: Bandage,
  banknote: Banknote,
  barcode: Barcode,
  barrel: Barrel,
  bath: Bath,
  battery: Battery,
  'battery-charging': BatteryCharging,
  'battery-full': BatteryFull,
  beaker: Beaker,
  bean: Bean,
  bed: Bed,
  'bed-double': BedDouble,
  'bed-single': BedSingle,
  beef: Beef,
  beer: Beer,
  bell: Bell,
  'bell-electric': BellElectric,
  'bell-off': BellOff,
  'bell-ring': BellRing,
  'biceps-flexed': BicepsFlexed,
  bike: Bike,
  binary: Binary,
  binoculars: Binoculars,
  biohazard: Biohazard,
  bird: Bird,
  birdhouse: Birdhouse,
  bitcoin: Bitcoin,
  blender: Blender,
  blinds: Blinds,
  blocks: Blocks,
  bluetooth: Bluetooth,
  'bluetooth-connected': BluetoothConnected,
  'bluetooth-searching': BluetoothSearching,
  bolt: Bolt,
  bomb: Bomb,
  bone: Bone,
  'bone-fracture': BoneFracture,
  book: Book,
  'book-a': BookA,
  'book-audio': BookAudio,
  'book-copy': BookCopy,
  'book-headphones': BookHeadphones,
  'book-heart': BookHeart,
  'book-image': BookImage,
  'book-key': BookKey,
  'book-lock': BookLock,
  'book-marked': BookMarked,
  'book-open': BookOpen,
  'book-open-text': BookOpenText,
  'book-text': BookText,
  'book-type': BookType,
  'book-user': BookUser,
  bookmark: Bookmark,
  'boom-box': BoomBox,
  bot: Bot,
  'bot-message-square': BotMessageSquare,
  'bottle-wine': BottleWine,
  'bow-arrow': BowArrow,
  box: Box,
  boxes: Boxes,
  braces: Braces,
  brackets: Brackets,
  brain: Brain,
  'brain-circuit': BrainCircuit,
  'brick-wall': BrickWall,
  'brick-wall-fire': BrickWallFire,
  'brick-wall-shield': BrickWallShield,
  bridge: Bridge,
  briefcase: Briefcase,
  'briefcase-business': BriefcaseBusiness,
  'briefcase-conveyor-belt': BriefcaseConveyorBelt,
  'briefcase-medical': BriefcaseMedical,
  broccoli: Broccoli,
  broom: Broom,
  'broom-sparkles': BroomSparkles,
  brush: Brush,
  'brush-cleaning': BrushCleaning,
  bubbles: Bubbles,
  bug: Bug,
  'bug-play': BugPlay,
  building: Building,
  'building-2': Building2,
  bus: Bus,
  'bus-front': BusFront,
  cable: Cable,
  'cable-car': CableCar,
  cake: Cake,
  'cake-slice': CakeSlice,
  calculator: Calculator,
  calendar: Calendar,
  'calendar-check': CalendarCheck,
  'calendar-clock': CalendarClock,
  'calendar-days': CalendarDays,
  'calendar-fold': CalendarFold,
  'calendar-heart': CalendarHeart,
  'calendar-range': CalendarRange,
  calendars: Calendars,
  camera: Camera,
  can: Can,
  'can-soda': CanSoda,
  candy: Candy,
  'candy-cane': CandyCane,
  cannabis: Cannabis,
  captions: Captions,
  car: Car,
  'car-battery': CarBattery,
  'car-front': CarFront,
  'car-taxi-front': CarTaxiFront,
  caravan: Caravan,
  'card-sim': CardSim,
  carrot: Carrot,
  'cassette-tape': CassetteTape,
  cast: Cast,
  castle: Castle,
  cat: Cat,
  cctv: Cctv,
  'chart-area': ChartArea,
  'chart-bar': ChartBar,
  'chart-candlestick': ChartCandlestick,
  'chart-column': ChartColumn,
  'chart-gantt': ChartGantt,
  'chart-line': ChartLine,
  'chart-network': ChartNetwork,
  'chart-pie': ChartPie,
  'chart-scatter': ChartScatter,
  'chart-spline': ChartSpline,
  check: Check,
  'chef-hat': ChefHat,
  cherry: Cherry,
  'chess-bishop': ChessBishop,
  'chess-king': ChessKing,
  'chess-knight': ChessKnight,
  'chess-pawn': ChessPawn,
  'chess-queen': ChessQueen,
  'chess-rook': ChessRook,
  church: Church,
  cigarette: Cigarette,
  circle: Circle,
  'circle-alert': CircleAlert,
  'circle-check': CircleCheck,
  'circle-user': CircleUser,
  'circuit-board': CircuitBoard,
  citrus: Citrus,
  clapperboard: Clapperboard,
  clipboard: Clipboard,
  'clipboard-check': ClipboardCheck,
  'clipboard-clock': ClipboardClock,
  'clipboard-copy': ClipboardCopy,
  'clipboard-list': ClipboardList,
  'clipboard-paste': ClipboardPaste,
  'clipboard-pen': ClipboardPen,
  'clipboard-type': ClipboardType,
  clock: Clock,
  'closed-caption': ClosedCaption,
  cloud: Cloud,
  'cloud-download': CloudDownload,
  'cloud-drizzle': CloudDrizzle,
  'cloud-fog': CloudFog,
  'cloud-hail': CloudHail,
  'cloud-lightning': CloudLightning,
  'cloud-moon': CloudMoon,
  'cloud-moon-rain': CloudMoonRain,
  'cloud-off': CloudOff,
  'cloud-rain': CloudRain,
  'cloud-rain-wind': CloudRainWind,
  'cloud-snow': CloudSnow,
  'cloud-sun': CloudSun,
  'cloud-sun-rain': CloudSunRain,
  'cloud-upload': CloudUpload,
  cloudy: Cloudy,
  clover: Clover,
  club: Club,
  code: Code,
  'code-xml': CodeXml,
  coffee: Coffee,
  cog: Cog,
  coins: Coins,
  command: Command,
  compass: Compass,
  component: Component,
  computer: Computer,
  'concierge-bell': ConciergeBell,
  cone: Cone,
  construction: Construction,
  contact: Contact,
  container: Container,
  cookie: Cookie,
  'cooking-pot': CookingPot,
  copyleft: Copyleft,
  copyright: Copyright,
  cpu: Cpu,
  'creative-commons': CreativeCommons,
  'credit-card': CreditCard,
  'credit-card-reader': CreditCardReader,
  croissant: Croissant,
  cross: Cross,
  crosshair: Crosshair,
  crown: Crown,
  cuboid: Cuboid,
  'cup-soda': CupSoda,
  currency: Currency,
  cylinder: Cylinder,
  dam: Dam,
  database: Database,
  'database-zap': DatabaseZap,
  dessert: Dessert,
  diamond: Diamond,
  'diamond-percent': DiamondPercent,
  dices: Dices,
  disc: Disc,
  'disc-album': DiscAlbum,
  dna: Dna,
  dog: Dog,
  'dollar-sign': DollarSign,
  donut: Donut,
  'door-closed-locked': DoorClosedLocked,
  'door-open': DoorOpen,
  'door-stairwell': DoorStairwell,
  download: Download,
  'drafting-compass': DraftingCompass,
  drama: Drama,
  drill: Drill,
  drone: Drone,
  droplet: Droplet,
  droplets: Droplets,
  drum: Drum,
  drumstick: Drumstick,
  dumbbell: Dumbbell,
  ear: Ear,
  earth: Earth,
  'earth-lock': EarthLock,
  eclipse: Eclipse,
  egg: Egg,
  'egg-fried': EggFried,
  engine: Engine,
  eraser: Eraser,
  'ethernet-port': EthernetPort,
  euro: Euro,
  'ev-charger': EvCharger,
  'external-link': ExternalLink,
  eye: Eye,
  'eye-off': EyeOff,
  'face-angry': FaceAngry,
  'face-expressionless': FaceExpressionless,
  'face-grinning': FaceGrinning,
  'face-neutral': FaceNeutral,
  'face-slightly-frowning': FaceSlightlyFrowning,
  'face-slightly-smiling': FaceSlightlySmiling,
  factory: Factory,
  fan: Fan,
  feather: Feather,
  fence: Fence,
  'ferris-wheel': FerrisWheel,
  file: FileIcon,
  'file-archive': FileArchive,
  'file-box': FileBox,
  'file-braces': FileBraces,
  'file-chart-column': FileChartColumn,
  'file-chart-column-increasing': FileChartColumnIncreasing,
  'file-chart-line': FileChartLine,
  'file-chart-pie': FileChartPie,
  'file-check': FileCheck,
  'file-clock': FileClock,
  'file-code': FileCode,
  'file-digit': FileDigit,
  'file-headphone': FileHeadphone,
  'file-heart': FileHeart,
  'file-image': FileImage,
  'file-key': FileKey,
  'file-lock': FileLock,
  'file-music': FileMusic,
  'file-pen': FilePen,
  'file-play': FilePlay,
  'file-signal': FileSignal,
  'file-sliders': FileSliders,
  'file-spreadsheet': FileSpreadsheet,
  'file-stack': FileStack,
  'file-terminal': FileTerminal,
  'file-text': FileText,
  'file-type': FileType,
  'file-user': FileUser,
  'file-video-camera': FileVideoCamera,
  'file-volume': FileVolume,
  files: Files,
  film: Film,
  'fingerprint-pattern': FingerprintPattern,
  'fire-extinguisher': FireExtinguisher,
  fish: Fish,
  'fish-symbol': FishSymbol,
  'fishing-hook': FishingHook,
  'fishing-rod': FishingRod,
  flag: Flag,
  'flag-triangle-left': FlagTriangleLeft,
  'flag-triangle-right': FlagTriangleRight,
  flame: Flame,
  'flame-kindling': FlameKindling,
  flashlight: Flashlight,
  'flask-conical': FlaskConical,
  flower: Flower,
  'flower-2': Flower2,
  folder: Folder,
  'folder-archive': FolderArchive,
  'folder-bookmark': FolderBookmark,
  'folder-clock': FolderClock,
  'folder-code': FolderCode,
  'folder-git': FolderGit,
  'folder-heart': FolderHeart,
  'folder-kanban': FolderKanban,
  'folder-key': FolderKey,
  'folder-lock': FolderLock,
  'folder-open': FolderOpen,
  'folder-tree': FolderTree,
  folders: Folders,
  footprints: Footprints,
  forklift: Forklift,
  fuel: Fuel,
  funnel: Funnel,
  galaxy: Galaxy,
  gamepad: Gamepad,
  'gamepad-2': Gamepad2,
  'gamepad-directional': GamepadDirectional,
  gauge: Gauge,
  gavel: Gavel,
  gem: Gem,
  'georgian-lari': GeorgianLari,
  germ: Germ,
  ghost: Ghost,
  gift: Gift,
  'git-branch': GitBranch,
  'git-commit-horizontal': GitCommitHorizontal,
  'git-commit-vertical': GitCommitVertical,
  'git-compare': GitCompare,
  'git-fork': GitFork,
  'git-graph': GitGraph,
  'git-merge': GitMerge,
  'git-pull-request': GitPullRequest,
  'glass-water': GlassWater,
  glasses: Glasses,
  globe: Globe,
  'globe-lock': GlobeLock,
  goal: Goal,
  gpu: Gpu,
  'graduation-cap': GraduationCap,
  grape: Grape,
  guitar: Guitar,
  ham: Ham,
  hamburger: Hamburger,
  hammer: Hammer,
  hand: Hand,
  'hand-coins': HandCoins,
  'hand-fist': HandFist,
  'hand-grab': HandGrab,
  'hand-heart': HandHeart,
  'hand-platter': HandPlatter,
  handbag: Handbag,
  handshake: Handshake,
  'hard-drive': HardDrive,
  'hard-hat': HardHat,
  hash: Hash,
  'hat-glasses': HatGlasses,
  haze: Haze,
  'hdmi-port': HdmiPort,
  headphones: Headphones,
  headset: Headset,
  heart: Heart,
  'heart-crack': HeartCrack,
  'heart-handshake': HeartHandshake,
  'heart-pulse': HeartPulse,
  heater: Heater,
  helicopter: Helicopter,
  'help-circle': HelpCircle,
  hexagon: Hexagon,
  highlighter: Highlighter,
  history: History,
  hop: Hop,
  hospital: Hospital,
  hotel: Hotel,
  hourglass: Hourglass,
  house: House,
  'house-heart': HouseHeart,
  'house-plug': HousePlug,
  'house-wifi': HouseWifi,
  'ice-cream-bowl': IceCreamBowl,
  'ice-cream-cone': IceCreamCone,
  'id-card': IdCard,
  'id-card-lanyard': IdCardLanyard,
  image: Image,
  'image-play': ImagePlay,
  'image-upscale': ImageUpscale,
  images: Images,
  inbox: Inbox,
  'indian-rupee': IndianRupee,
  infinity: InfinityIcon,
  info: Info,
  'inspection-panel': InspectionPanel,
  'japanese-yen': JapaneseYen,
  joystick: Joystick,
  kanban: Kanban,
  kayak: Kayak,
  key: Key,
  'key-round': KeyRound,
  'key-square': KeySquare,
  keyboard: Keyboard,
  'keyboard-music': KeyboardMusic,
  lamp: Lamp,
  'lamp-ceiling': LampCeiling,
  'lamp-desk': LampDesk,
  'lamp-floor': LampFloor,
  'land-plot': LandPlot,
  landmark: Landmark,
  languages: Languages,
  laptop: Laptop,
  'laptop-minimal': LaptopMinimal,
  layers: Layers,
  leaf: Leaf,
  'leafy-green': LeafyGreen,
  lectern: Lectern,
  'lens-concave': LensConcave,
  'lens-convex': LensConvex,
  library: Library,
  'life-buoy': LifeBuoy,
  ligature: Ligature,
  lightbulb: Lightbulb,
  'lightbulb-off': LightbulbOff,
  lighthouse: Lighthouse,
  link: Link,
  'link-2': Link2,
  list: List,
  'list-check': ListCheck,
  'list-checks': ListChecks,
  'list-clock': ListClock,
  'list-music': ListMusic,
  'list-todo': ListTodo,
  lock: Lock,
  'lock-keyhole': LockKeyhole,
  'lock-keyhole-open': LockKeyholeOpen,
  'lock-open': LockOpen,
  lollipop: Lollipop,
  luggage: Luggage,
  magnet: Magnet,
  mail: Mail,
  'mail-check': MailCheck,
  'mail-clock': MailClock,
  'mail-open': MailOpen,
  mailbox: Mailbox,
  mails: Mails,
  map: MapIcon,
  'map-pin': MapPin,
  'map-pin-house': MapPinHouse,
  'map-pinned': MapPinned,
  mars: Mars,
  'mars-stroke': MarsStroke,
  martini: Martini,
  medal: Medal,
  megaphone: Megaphone,
  'memory-stick': MemoryStick,
  'message-circle': MessageCircle,
  'message-circle-code': MessageCircleCode,
  'message-circle-heart': MessageCircleHeart,
  'message-square': MessageSquare,
  'message-square-code': MessageSquareCode,
  'message-square-heart': MessageSquareHeart,
  'message-square-lock': MessageSquareLock,
  'message-square-quote': MessageSquareQuote,
  'message-square-share': MessageSquareShare,
  'message-square-text': MessageSquareText,
  'messages-square': MessagesSquare,
  metronome: Metronome,
  mic: Mic,
  'mic-off': MicOff,
  'mic-vocal': MicVocal,
  microchip: Microchip,
  microscope: Microscope,
  microwave: Microwave,
  'midi-port': MidiPort,
  milestone: Milestone,
  milk: Milk,
  'mirror-rectangular': MirrorRectangular,
  monitor: Monitor,
  'monitor-cloud': MonitorCloud,
  'monitor-off': MonitorOff,
  'monitor-pause': MonitorPause,
  'monitor-play': MonitorPlay,
  'monitor-smartphone': MonitorSmartphone,
  'monitor-speaker': MonitorSpeaker,
  'monitor-stop': MonitorStop,
  moon: Moon,
  'moon-star': MoonStar,
  mop: Mop,
  'mop-sparkles': MopSparkles,
  mosque: Mosque,
  motorbike: Motorbike,
  mountain: Mountain,
  'mountain-snow': MountainSnow,
  mouse: Mouse,
  'mouse-left': MouseLeft,
  'mouse-right': MouseRight,
  music: Music,
  navigation: Navigation,
  network: Network,
  newspaper: Newspaper,
  nfc: Nfc,
  notebook: Notebook,
  'notebook-pen': NotebookPen,
  'notebook-tabs': NotebookTabs,
  'notebook-text': NotebookText,
  'notepad-text': NotepadText,
  nut: Nut,
  omega: Omega,
  orbit: Orbit,
  origami: Origami,
  package: Package,
  'package-2': Package2,
  'package-check': PackageCheck,
  'package-open': PackageOpen,
  'paint-bucket': PaintBucket,
  'paint-roller': PaintRoller,
  paintbrush: Paintbrush,
  'paintbrush-vertical': PaintbrushVertical,
  palette: Palette,
  panda: Panda,
  'paper-bag': PaperBag,
  paperclip: Paperclip,
  parasol: Parasol,
  parentheses: Parentheses,
  'parking-meter': ParkingMeter,
  'party-popper': PartyPopper,
  'paw-print': PawPrint,
  'pc-case': PcCase,
  pen: Pen,
  'pen-line': PenLine,
  'pen-tool': PenTool,
  pencil: Pencil,
  'pencil-line': PencilLine,
  'pencil-ruler': PencilRuler,
  'pencil-sparkles': PencilSparkles,
  pentagon: Pentagon,
  percent: Percent,
  'person-standing': PersonStanding,
  phi: Phi,
  'philippine-peso': PhilippinePeso,
  phone: Phone,
  'phone-call': PhoneCall,
  pi: Pi,
  piano: Piano,
  pickaxe: Pickaxe,
  'piggy-bank': PiggyBank,
  pill: Pill,
  'pill-bottle': PillBottle,
  pin: Pin,
  pipette: Pipette,
  pizza: Pizza,
  plane: Plane,
  'plane-landing': PlaneLanding,
  'plane-takeoff': PlaneTakeoff,
  'playing-card': PlayingCard,
  'playing-cards': PlayingCards,
  'playing-cards-fan': PlayingCardsFan,
  plug: Plug,
  'plug-zap': PlugZap,
  'pocket-knife': PocketKnife,
  podium: Podium,
  popcorn: Popcorn,
  popsicle: Popsicle,
  'pound-sterling': PoundSterling,
  power: Power,
  presentation: Presentation,
  printer: Printer,
  projector: Projector,
  puzzle: Puzzle,
  pyramid: Pyramid,
  'qr-code': QrCode,
  quote: Quote,
  rabbit: Rabbit,
  radar: Radar,
  radiation: Radiation,
  radical: Radical,
  radio: Radio,
  'radio-receiver': RadioReceiver,
  'radio-tower': RadioTower,
  rainbow: Rainbow,
  rat: Rat,
  receipt: Receipt,
  'receipt-text': ReceiptText,
  recycle: Recycle,
  'refresh-ccw': RefreshCcw,
  'refresh-cw': RefreshCw,
  refrigerator: Refrigerator,
  regex: Regex,
  repeat: Repeat,
  reply: Reply,
  ribbon: Ribbon,
  road: Road,
  'robot-arm': RobotArm,
  'robot-vacuum': RobotVacuum,
  rocket: Rocket,
  'rocking-chair': RockingChair,
  'roller-coaster': RollerCoaster,
  rose: Rose,
  'rotate-cw': RotateCw,
  route: Route,
  router: Router,
  rss: Rss,
  ruler: Ruler,
  'ruler-dimension-line': RulerDimensionLine,
  'russian-ruble': RussianRuble,
  sailboat: Sailboat,
  salad: Salad,
  sandwich: Sandwich,
  satellite: Satellite,
  'satellite-dish': SatelliteDish,
  'saudi-riyal': SaudiRiyal,
  save: Save,
  scale: Scale,
  scan: Scan,
  school: School,
  scissors: Scissors,
  scooter: Scooter,
  'screen-share': ScreenShare,
  scroll: Scroll,
  'scroll-text': ScrollText,
  search: Search,
  'search-check': SearchCheck,
  'search-code': SearchCode,
  send: Send,
  'send-horizontal': SendHorizontal,
  server: Server,
  'server-crash': ServerCrash,
  settings: Settings,
  shapes: Shapes,
  share: Share,
  'share-2': Share2,
  shell: Shell,
  'shelving-unit': ShelvingUnit,
  shield: Shield,
  'shield-check': ShieldCheck,
  'shield-keyhole': ShieldKeyhole,
  'shield-lock': ShieldLock,
  'shield-user': ShieldUser,
  ship: Ship,
  'ship-cargo': ShipCargo,
  'ship-wheel': ShipWheel,
  shirt: Shirt,
  'shopping-bag': ShoppingBag,
  'shopping-basket': ShoppingBasket,
  'shopping-cart': ShoppingCart,
  shovel: Shovel,
  'shower-head': ShowerHead,
  shredder: Shredder,
  shrimp: Shrimp,
  shrub: Shrub,
  sigma: Sigma,
  signal: Signal,
  signpost: Signpost,
  siren: Siren,
  skull: Skull,
  'sliders-horizontal': SlidersHorizontal,
  'sliders-vertical': SlidersVertical,
  smartphone: Smartphone,
  'smartphone-charging': SmartphoneCharging,
  'smartphone-nfc': SmartphoneNfc,
  smile: Smile,
  snail: Snail,
  snowflake: Snowflake,
  'soap-dispenser-droplet': SoapDispenserDroplet,
  sofa: Sofa,
  'solar-panel': SolarPanel,
  soup: Soup,
  spade: Spade,
  sparkle: Sparkle,
  sparkles: Sparkles,
  speaker: Speaker,
  speech: Speech,
  spline: Spline,
  'sport-shoe': SportShoe,
  spotlight: Spotlight,
  'spray-can': SprayCan,
  sprout: Sprout,
  square: Square,
  'square-check': SquareCheck,
  'square-kanban': SquareKanban,
  'square-library': SquareLibrary,
  'square-pen': SquarePen,
  'square-terminal': SquareTerminal,
  squirrel: Squirrel,
  stamp: Stamp,
  star: Star,
  stethoscope: Stethoscope,
  sticker: Sticker,
  'sticky-note': StickyNote,
  'sticky-notes': StickyNotes,
  store: Store,
  sun: Sun,
  'sun-moon': SunMoon,
  'sun-snow': SunSnow,
  sunrise: Sunrise,
  sunset: Sunset,
  'swatch-book': SwatchBook,
  'swiss-franc': SwissFranc,
  sword: Sword,
  swords: Swords,
  syringe: Syringe,
  table: Table,
  'table-2': Table2,
  'table-of-contents': TableOfContents,
  'table-properties': TableProperties,
  tablet: Tablet,
  'tablet-smartphone': TabletSmartphone,
  tablets: Tablets,
  tag: Tag,
  tags: Tags,
  target: Target,
  telescope: Telescope,
  tent: Tent,
  'tent-tree': TentTree,
  terminal: Terminal,
  'test-tube': TestTube,
  'test-tube-diagonal': TestTubeDiagonal,
  'test-tubes': TestTubes,
  theater: Theater,
  thermometer: Thermometer,
  'thermometer-snowflake': ThermometerSnowflake,
  'thermometer-sun': ThermometerSun,
  ticket: Ticket,
  'ticket-percent': TicketPercent,
  tickets: Tickets,
  'tickets-plane': TicketsPlane,
  timeline: Timeline,
  timer: Timer,
  'timer-reset': TimerReset,
  toilet: Toilet,
  'tool-case': ToolCase,
  toolbox: Toolbox,
  tornado: Tornado,
  torus: Torus,
  touchpad: Touchpad,
  'towel-rack': TowelRack,
  'tower-control': TowerControl,
  'toy-brick': ToyBrick,
  tractor: Tractor,
  'traffic-cone': TrafficCone,
  trailer: Trailer,
  'train-front': TrainFront,
  'train-front-tunnel': TrainFrontTunnel,
  'train-track': TrainTrack,
  'tram-front': TramFront,
  transgender: Transgender,
  trash: Trash,
  'tree-deciduous': TreeDeciduous,
  'tree-palm': TreePalm,
  'tree-pine': TreePine,
  trees: Trees,
  'trending-down': TrendingDown,
  'trending-up': TrendingUp,
  triangle: Triangle,
  'triangle-right': TriangleRight,
  trophy: Trophy,
  truck: Truck,
  'truck-electric': TruckElectric,
  'turkish-lira': TurkishLira,
  turntable: Turntable,
  turtle: Turtle,
  tv: Tv,
  'tv-minimal': TvMinimal,
  'tv-minimal-play': TvMinimalPlay,
  umbrella: Umbrella,
  university: University,
  unlock: Unlock,
  unplug: Unplug,
  upload: Upload,
  usb: Usb,
  'usb-c-port': UsbCPort,
  user: User,
  'user-check': UserCheck,
  'user-key': UserKey,
  'user-lock': UserLock,
  'user-plus': UserPlus,
  'user-round': UserRound,
  'user-shield': UserShield,
  'user-star': UserStar,
  users: Users,
  utensils: Utensils,
  'utensils-crossed': UtensilsCrossed,
  'utility-pole': UtilityPole,
  van: Van,
  variable: Variable,
  vault: Vault,
  vegan: Vegan,
  'venetian-mask': VenetianMask,
  venus: Venus,
  'venus-and-mars': VenusAndMars,
  vibrate: Vibrate,
  video: Video,
  'video-off': VideoOff,
  videotape: Videotape,
  virus: Virus,
  voicemail: Voicemail,
  volleyball: Volleyball,
  volume: Volume,
  'volume-off': VolumeOff,
  vote: Vote,
  wallet: Wallet,
  'wallet-cards': WalletCards,
  'wallet-minimal': WalletMinimal,
  wallpaper: Wallpaper,
  wand: Wand,
  'wand-sparkles': WandSparkles,
  warehouse: Warehouse,
  'washing-machine': WashingMachine,
  watch: Watch,
  'waves-horizontal': WavesHorizontal,
  'waves-ladder': WavesLadder,
  'waves-vertical': WavesVertical,
  waypoints: Waypoints,
  webcam: Webcam,
  webhook: Webhook,
  weight: Weight,
  wheat: Wheat,
  whistle: Whistle,
  wifi: Wifi,
  'wifi-off': WifiOff,
  wind: Wind,
  wine: Wine,
  workflow: Workflow,
  worm: Worm,
  wrench: Wrench,
  zap: Zap,
  'zodiac-aquarius': ZodiacAquarius,
  'zodiac-aries': ZodiacAries,
  'zodiac-cancer': ZodiacCancer,
  'zodiac-capricorn': ZodiacCapricorn,
  'zodiac-gemini': ZodiacGemini,
  'zodiac-leo': ZodiacLeo,
  'zodiac-libra': ZodiacLibra,
  'zodiac-ophiuchus': ZodiacOphiuchus,
  'zodiac-pisces': ZodiacPisces,
  'zodiac-sagittarius': ZodiacSagittarius,
  'zodiac-scorpio': ZodiacScorpio,
  'zodiac-taurus': ZodiacTaurus,
  'zodiac-virgo': ZodiacVirgo,
};

export function noteIconGlyph(name: string) {
  return isNoteIconName(name) ? drawn[name] : null;
}

/**
 * Renders a stored page icon. A name draws from the bundled set; anything else
 * is an emoji saved before the set existed and is rendered as text. The optional
 * tone paints the shared semantic background behind it.
 */
export function NoteIcon({
  icon,
  tone,
  className,
}: {
  icon: string;
  tone?: string | null;
  className?: string;
}) {
  const Glyph = noteIconGlyph(icon);

  return (
    <span
      aria-hidden="true"
      className={['ui-note-icon', tone && `tone-${tone}`, className].filter(Boolean).join(' ')}
      data-toned={tone ? 'true' : undefined}
    >
      {Glyph ? <Glyph /> : icon}
    </span>
  );
}
